module.exports = "/dist/images/defaultHero.1c19e242.png";